import React from "react"
import { Provider as GreenhouseProvider } from "src/utils/context/greenhouse"

export const wrapRootElement = ({ element }) => {
  return <GreenhouseProvider>{element}</GreenhouseProvider>
}
